// extracted by mini-css-extract-plugin
module.exports = {"page_title":"AboutPage_page_title__2bXeJ","page_subtitle":"AboutPage_page_subtitle__3NHto"};